import PropTypes from 'prop-types';

const Finance = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="40" viewBox="0 0 38 40" {...props}>
    <path
      fill={colour}
      d="M8.762 15.081v-3.318h2.727c-.329-1.172-.657-2.508-.657-4.228C10.832 2.782 14.019 0 18.52 0c5.126 0 7.459 3.406 7.59 7.535h-4.238s-.92-3.537-3.286-3.537c-1.971 0-3.351 1.172-3.351 3.921 0 1.347.361 2.617.723 3.855h6.177v3.297h-5.356c.033.273.066.547.066.821 0 1.895-.657 3.954-2.202 5.575h11.643v3.855H10.339l-.723-2.475c1.84-1.884 2.859-3.713 2.859-6.977 0-.247-.027-.467-.056-.709l-.01-.08H8.762Zm19.331-7.677a12.485 12.485 0 0 0-.449-2.859c5.717 3.176 9.594 9.277 9.594 16.286 0 10.285-8.335 18.62-18.619 18.62C8.335 39.451 0 31.116 0 20.831 0 13.986 3.702 7.995 9.2 4.764a11.35 11.35 0 0 0-.34 2.793v.055c-4.041 2.99-6.67 7.798-6.67 13.219 0 4.546 1.84 8.653 4.809 11.621 1.857 1.851 4.149 1.134 6.713.332 1.548-.485 3.196-1 4.907-1 1.711 0 3.361.515 4.91 1 2.567.802 4.86 1.519 6.71-.332a16.415 16.415 0 0 0 4.809-11.621c0-5.552-2.749-10.448-6.955-13.427Z"
    ></path>
  </svg>
);

Finance.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Finance;
